import { useTranslation as i18useTranslation } from 'react-i18next';
import { Locales } from '../locales/types';

export const useTranslation: <T>(
  ns: keyof Locales
) => { t: (key: keyof T, options?: any) => string } = (ns) =>
  i18useTranslation(ns as string);
